module.exports = __webpack_public_path__ + "static/img/101365.2188dbfd.png";